<template>
  <span
    v-if="priorityOption"
    class="flagdot d-flex align-items-center"
  >
    <span
      class="dot"
      :style="style"
    />
    <i
      v-tooltip="priorityOption.name"
      :style="style"
      class="fas fa-flag mr-1 priority-icon showtooltip"
      aria-hidden="true"
    />
    <i
      :style="style"
      class="fas fa-flag mr-1 priority-icon noshowtooltip"
      aria-hidden="true"
    />
    <span
      v-show="showLabel"
      class="ml-2"
      :style="style"
    >{{ priorityOption.name }}</span>
  </span>
</template>

<script>

import sessionStore from '@/session/sessionStore'

export default {
    name: 'StatusRequestPriorityDot',
    props: {
        priorityLevel: { type: Number },
        priority: { type: Object },
        size: { type: Number, default: 6 },
        showLabel: { type: Boolean, default: false }
    },
    data() {
        return {
            priorities: sessionStore.state.priorities
        }
    },
    computed: {
        style() {
            /* return { 'background-color': this.priorityOption.color, width: `${this.size}px`, height: `${this.size}px` } */
            return { 'color': this.priorityOption?.color }
        },
        priorityOption() {
            const priority = this.priorities.find(p => p.level === this.priorityLevel)
            return priority ?? this.priority
        }
    }
}

</script>

<style lang="scss">

.request-sidepanel .showtooltip,
.viewRequest .showtooltip {
  display: block !important;
  cursor: pointer;
}

.request-sidepanel .noshowtooltip,
.viewRequest .noshowtooltip {
  display: none !important;
}

</style>

<style scoped lang="scss">

/* .dot {
  display: inline-block;
  margin-right: .5rem;
  border-radius: 50%;
} */

.priority-icon{
  font-size: 0.85rem;
}

.vt-grid span{
    display: none;
}

.ag-virtual-list-container span{
  display: block;
}

.showtooltip{
  display: none;
}

.noshowtooltip{
  display: block;
}

.vt-grid .showtooltip{
  display: block;
}

.vt-grid .noshowtooltip{
  display: none;
}

</style>
